const TOKEN_LABEL = "MyGorgeousPricingSession"

export const get = () => window.localStorage.getItem(TOKEN_LABEL)

export const save = token => window.localStorage.setItem(TOKEN_LABEL, token)

export const forget = () => window.localStorage.removeItem(TOKEN_LABEL)
